import type { FC } from "react";

import { Column } from "@hightouch/htui";

import { useViewHeight } from "src/components/layout/view-height";
import { useHeaderHeight } from "src/contexts/header-height-context";

import type { PageSidebarContainerProps } from "./types";
import { PAGE_SIDEBAR_OPEN_WIDTH_PX, SidebarName } from "./constants";

export const PageSidebarContainer: FC<Readonly<PageSidebarContainerProps>> = ({
  children,
  hideRightBorder = false,
  ignoreHeaderHeight = false,
  name = SidebarName.Filter,
  width = PAGE_SIDEBAR_OPEN_WIDTH_PX,
  alignItems = "center",
  ...props
}) => {
  const { headerHeight } = useHeaderHeight();
  // In settings' inset panel a viewport-tall rail would overflow it, scrolling the page card up past the panel's top.
  const viewHeight = useViewHeight("100vh");

  return (
    <Column
      as="aside"
      aria-label={`${name}`}
      pos="sticky"
      top={ignoreHeaderHeight ? 0 : -2}
      borderRightWidth={hideRightBorder ? undefined : "hairline"}
      borderRightStyle={hideRightBorder ? undefined : "solid"}
      borderColor="transparent"
      flexShrink={0}
      overscrollBehavior="none"
      alignItems={alignItems}
      width={width}
      height={
        ignoreHeaderHeight
          ? undefined
          : `calc(${viewHeight} - ${headerHeight}px)`
      }
      {...props}
    >
      {children}
    </Column>
  );
};
